import { dataHooks } from '../../../libs/dataHooks';

export const subHeaderDataHooks = dataHooks<{
  breadcrumbs: {};
  subTitle: {};
  subText: {};
  subCategories: {};
  sortMenu: {};
}>('subHeader');
